import { ComponentProps, ReactNode } from 'react';
import {
  Input as AriaInput,
  NumberField as AriaNumberField,
  Group as AriaGroup,
  Button as AriaButton,
} from 'react-aria-components';
import { twMerge } from 'tailwind-merge';
import { input, InputVariants } from '../../patterns/input';
import { inputWrapper } from './variants';
import { IconMinus, IconPlus } from '@maia/icons';

type Props = {
  className?: string;
  icon?: ReactNode;
  tooltipSlot?: ReactNode;
  fieldSize?: InputVariants['size'];
  placeholder?: string;
} & Omit<ComponentProps<typeof AriaNumberField>, 'className'>;

export function NumberInput(props: Props) {
  const {
    className,
    icon,
    tooltipSlot,
    placeholder,
    fieldSize = 'default',
    ...rest
  } = props;

  return (
    <AriaNumberField
      {...rest}
      formatOptions={{
        useGrouping: false,
      }}
    >
      <AriaGroup
        className={twMerge(inputWrapper({ size: fieldSize }), className)}
      >
        <AriaInput
          placeholder={placeholder}
          className={twMerge(
            input({ size: fieldSize }),
            'placeholder:font-light',
            'col-start-1',
            'col-end-4',
            'row-start-1',
            'row-end-1',
            'peer',
            'pl-48',
            'pr-48',
          )}
        />
        <AriaButton
          className={twMerge(
            'flex',
            'justify-center',
            'items-center',
            'size-full',
            'col-start-1',
            'col-end-1',
            'row-start-1',
            'row-end-1',
            'leading-0',
            'transition-colors',
            'duration-200',
            'ease-out',
            'fill-grayscale300',
            'peer-data-[hovered="true"]:fill-primaryMain',
            'peer-data-[focused="true"]:fill-primaryMain',
          )}
          slot="decrement"
        >
          <IconMinus />
        </AriaButton>
        <AriaButton
          className={twMerge(
            'flex',
            'justify-center',
            'items-center',
            'size-full',
            'col-start-3',
            'col-end-4',
            'row-start-1',
            'row-end-1',
            'place-self-center',
            'leading-0',
            'transition-colors',
            'duration-200',
            'ease-out',
            'fill-grayscale300',
            'peer-data-[hovered="true"]:fill-primaryMain',
            'peer-data-[focused="true"]:fill-primaryMain',
          )}
          slot="increment"
        >
          <IconPlus />
        </AriaButton>
      </AriaGroup>
    </AriaNumberField>
  );
}
